import { formatDateOnlyShort } from '@/app/utils/formatDate';
import { formatMileage } from '@/features/vehiclesearch/utils/mileage';
import type { AgreementInvoice } from '../types/agreements.types';

export function invoiceMetaLine(invoice: AgreementInvoice, dealerName: string): string {
    const segments = [
        formatDateOnlyShort(invoice.invoicedAt),
        invoice.mileage === null ? null : `${formatMileage(invoice.mileage)} miles`,
        dealerName,
    ];
    return segments.filter((segment) => segment !== null).join(' · ');
}
